import {setupButtonClick} from "../utils/ui";
import LocalStorage from "../utils/localStorage";
import config from "../config";
import DbClient from "../db/client";

const GOLD_COLOR = "#FFD700";
const SILVER_COLOR = "#808080";
const BRONCE_COLOR = "#bf8970";
const GREEN_COLOR = "#115511";

export default class HighscorePanel {
    static preload(scene){
    }

    constructor({scene}) {
        this.scene = scene;

        this.currentChunk = 0;

        this.panel = this.scene.add.image(
            this.scene.game.config.width / 2,
            this.scene.game.config.height / 2,
            "board"
        );
        this.panel.setScale(0.6);

        this.panel.setInteractive();

        this.highscoreText = this.scene.add.text(this.scene.game.config.width / 2,
            this.scene.game.config.height / 2 - 220, 'Highscore',
            {
                fill: "#141",
                fontSize: "50px",
                fontFamily: "Splurge"
            });

        this.highscoreText.setOrigin(0.5);

        this.currentHighscore = "Local";

        this.subHighscoreText = this.scene.add.text(
            this.scene.game.config.width / 2,
            this.scene.game.config.height / 2 - 185,
            this.currentHighscore,
            {
                fill: GREEN_COLOR,
                fontSize: "30px",
                fontFamily: "Splurge"
            });

        this.subHighscoreText.setOrigin(0.5);

        this.container = this.scene.rexUI.add.sizer({
            orientation: "x",
            anchor: "center",
            x: this.scene.game.config.width / 2,
            y: this.scene.game.config.height / 2
        });

        this.homeBtn =  this.scene.add.image(
            this.scene.game.config.width - 70,
            70,
            "btn_home"
        );

        this.homeBtn.setScale(0.15);

        setupButtonClick(this.homeBtn, () => {
            if(this.hidden) return;
            setTimeout(() => {this.hide();}, 0)
            this.homeBtn.actived = false;
        })

        this.scores= [];


        this.createControlButtons();
        this.hide();

        this.localHighscore = LocalStorage.getHighscore();
        DbClient
            .getHighscore()
            .then(globalHighscore => {
                this.globalHighscore = globalHighscore;
                this.createHighscores();
                this.hide();
            })
            .catch(e => {
                this.hide();
            })
    }

    createControlButtons(){
        this.btnLeft = this.scene.add.image(
            this.scene.game.config.width / 2 - 300,
            this.scene.game.config.height / 2 - 150,
            "gamepad_button_left"
        );
        this.btnLeft.setScale(0.25);

        setupButtonClick(this.btnLeft, () => {
            this.btnLeft.actived = false;
            this.switchHighscore();
        })

        this.btnRight = this.scene.add.image(
            this.scene.game.config.width / 2 + 300,
            this.scene.game.config.height / 2 - 150,
            "gamepad_button_right"
        );
        this.btnRight.setScale(0.25);

        setupButtonClick(this.btnRight, () => {
            this.btnRight.actived = false;
            this.switchHighscore();
        })

        this.btnUp = this.scene.add.image(
            this.scene.game.config.width / 2 - 70,
            this.scene.game.config.height / 2 + 200,
            "gamepad_button_up"
        );
        this.btnUp.setScale(0.25);

        setupButtonClick(this.btnUp, () => {
            this.btnUp.actived = false;
            this.scrollHighscoreUp();
        })

        this.btnDown = this.scene.add.image(
            this.scene.game.config.width / 2 + 70,
            this.scene.game.config.height / 2 + 200,
            "gamepad_button_down"
        );
        this.btnDown.setScale(0.25);

        setupButtonClick(this.btnDown, () => {
            this.btnDown.actived = false;
            this.scrollHighscoreDown();
        })

    }

    switchHighscore(){
        if(this.currentHighscore === "Local"){
            this.currentHighscore = "Global";
            this.subHighscoreText.setFill(GOLD_COLOR);
            this.createHighscores()
        } else if(this.currentHighscore === "Global"){
            this.currentHighscore = "Local";
            this.subHighscoreText.setFill(GREEN_COLOR);
            this.createHighscores()
        }

        this.subHighscoreText.setText(this.currentHighscore);
    }

    scrollHighscoreDown(){
        if((this.currentChunk + 1) * config.HIGHSCORE.SIZE < config.HIGHSCORE.ENTRIES) {
            this.currentChunk++;
            this.createHighscores();
        }
    }

    scrollHighscoreUp(){
        if(this.currentChunk > 0) {
            this.currentChunk--;
            this.createHighscores();
        }
    }

    createHighscores(){
        if(this.currentHighscore === "Local"){
            this.createHighscore(this.localHighscore);
        } else if(this.currentHighscore === "Global") {
            this.createHighscore(this.globalHighscore);
        }
    }

    createHighscore(highscore){
        if(this.scores && this.scores.length){
            this.scores.forEach(s => s.destroy());
        }
        this.scores = [];

        for(let idx = 0; idx < config.HIGHSCORE.ENTRIES; idx++){
            const start = this.currentChunk * config.HIGHSCORE.SIZE;
            const end = start + config.HIGHSCORE.SIZE - 1;

            if(idx > end || idx < start) continue;

            const highscoreEntry = highscore[idx];
            const rank = idx + 1;

            let fill = "#D8D741";
            if(rank === 1) fill = GOLD_COLOR;
            if(rank === 2) fill = SILVER_COLOR;
            if(rank === 3) fill = BRONCE_COLOR;

            const container = this.scene.rexUI.add.sizer({
                orientation: "x",
                anchor: "left",
                x: this.scene.game.config.width / 5,
                y: this.scene.game.config.height / 2 - 50 + (idx % config.HIGHSCORE.SIZE) * 70,
                space: { left: 0, right:0, top:0, bottom:0, },
                width: 450
            });
            container.setOrigin(0, 0.5);

            const rankSizer = this.scene.rexUI.add.overlapSizer({
                x: 0,
                y: 0,
                // anchor: undefined,
                // width: undefined,
                // height: undefined,
                // space: { left: 0, right:0, top:0, bottom:0 },

                // name: '',
                // draggable: false,
                // sizerEvents: false,
                // enableLayer: false,
            });

            const rankTextBehind = this.scene.add.text(0, 0, `${rank}.`,
                {
                    fill: "#000",
                    fontSize: "65px",
                    fontFamily: "Splurge"
                });
            const rankText = this.scene.add.text(0, 0, `${rank}.`,
                {
                    fill,
                    fontSize: "60px",
                    fontFamily: "Splurge"
                });

            rankSizer.add(rankTextBehind, {align: "center"});
            rankSizer.add(rankText, {align: "center"});

            rankSizer.layout();

            const nameText = this.scene.add.text(0, 0, highscoreEntry?.name || "",
                {
                    fill,
                    fontSize: "50px",
                    fontFamily: "Splurge"
                });

            const scoreSizer = this.scene.rexUI.add.overlapSizer({
                x: 0,
                y: 0,
                // anchor: undefined,
                // width: undefined,
                // height: undefined,
                // space: { left: 0, right:0, top:0, bottom:0 },

                // name: '',
                // draggable: false,
                // sizerEvents: false,
                // enableLayer: false,
            });

            const scoreTextBehind = this.scene.add.text(0, 0, highscoreEntry?.score || "",
                {
                    fill: "#000",
                    fontSize: "65px",
                    fontFamily: "Splurge"
                });
            const scoreText = this.scene.add.text(0, 0, highscoreEntry?.score || "",
                {
                    fill,
                    fontSize: "60px",
                    fontFamily: "Splurge"
                });
            scoreSizer.add(scoreTextBehind, {align: "center"});
            scoreSizer.add(scoreText, {align: "center"});

            scoreSizer.layout();
            container.add(rankSizer);
            container.addSpace();
            container.add(nameText, {padding: {left: 20}});
            container.addSpace();
            container.add(scoreSizer, {align: "right"});
            container.layout();
            container.setDepth(2);
            this.scores[idx] = container;
        }
    }

    hide(){
        this.hidden = true;

        this.container.visible = false;
        this.panel.visible = false;
        this.highscoreText.visible = false;
        this.subHighscoreText.visible = false;
        this.homeBtn.visible = false;
        this.btnLeft.visible = false;
        this.btnRight.visible = false;
        this.btnDown.visible = false;
        this.btnUp.visible = false;
        this.scores.forEach(s => {s.visible = false;})

        this.container.setDepth(1);
        this.panel.setDepth(1);
        this.highscoreText.setDepth(1);
        this.subHighscoreText.setDepth(1);
        this.homeBtn.setDepth(1);
        this.btnLeft.setDepth(1);
        this.btnRight.setDepth(1);
        this.btnDown.setDepth(1);
        this.btnUp.setDepth(1);
        this.scores.forEach(s => {s.setDepth(1);})
    }

    show(){
        this.container.visible = true;
        this.panel.visible = true;
        this.highscoreText.visible = true;
        this.subHighscoreText.visible = true;
        this.homeBtn.visible = true;
        this.btnLeft.visible = true;
        this.btnRight.visible = true;
        this.btnDown.visible = true;
        this.btnUp.visible = true;
        this.scores.forEach(s => {s.visible = true;})

        this.container.setDepth(2);
        this.panel.setDepth(2);
        this.highscoreText.setDepth(2);
        this.subHighscoreText.setDepth(2);
        this.homeBtn.setDepth(2);
        this.btnLeft.setDepth(2);
        this.btnRight.setDepth(2);
        this.btnDown.setDepth(2);
        this.btnUp.setDepth(2);
        this.scores.forEach(s => {s.setDepth(2);})

        setTimeout(() => {
            this.hidden = false;
        },0)
    }
}